export default __webpack_public_path__ + "static/media/No-mic.a01f9106.png";